















































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";
import Add from "./article-cate/add.vue";
import Edit from "./article-cate/edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "articleCate/list";
  dispatchTypeDelete = "articleCate/delete";

  infoModalVisible = false;

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "名称", dataIndex: "name" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
